import "core-js/modules/es6.object.assign";
import NullLog from './null-log';
export function mergeLoaderAndUserOptions(options, loader) {
  options = Object.assign({}, loader && loader.DEFAULT_OPTIONS, loader && loader.defaultOptions, loader && loader.options, options, {
    dataType: 'arraybuffer'
  });

  if (options.log === null) {
    options.log = new NullLog();
  }

  if (!('log' in options)) {
    options.log = console;
  }

  return options;
}